function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 14,
  fill: "#315A9D"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M17.733 7.56v2.074h-1.187c-.433 0-.726.094-.877.283-.151.188-.227.47-.227.848v1.484h2.216l-.295 2.324h-1.92v5.96h-2.315v-5.96H11.2V12.25h1.928v-1.712c0-.974.262-1.729.787-2.265.524-.537 1.222-.805 2.094-.805.741 0 1.316.031 1.724.094z"
}));

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28
  }, props), _ref);
}

export default SvgFacebook;